const statuses = {
	active: 'active',
	hidden: 'hidden',
	stopped: 'stopped'
};

const locale = {
	ru: {
		active: 'активен',
		hidden: 'скрыт',
		stopped: 'остановлен'
	},
	en: statuses,
	uk: statuses,
	de: {
		active: 'aktiv',
		hidden: 'versteckt',
		stopped: 'gestoppt'
	},
	vi: statuses,
	th: {
		active: 'ใช้งานได้',
		hidden: 'ถูกซ่อน',
		stopped: 'หยุดแล้ว'
	}
};

module.exports = {
	enum: statuses,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/offer-statuses.js